// i18n area 'system' — locale uk-UA (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.uk-UA.meta.json.
import type { enUS } from './system'

export const ukUA: typeof enUS = {
  diagnostics: {
    title: 'Діагностика',
    subtitle: 'Що не так, найгірше спочатку — та сама лінза, що й tvirt diagnose',
    reload: 'Перезавантажити',
    loadError: 'Не вдалося прочитати діагностику',
    exportBundle: 'Експортувати пакет',
    exportError: 'Не вдалося створити пакет',
    noProblem: 'Проблем у перевірених областях немає',
    nothingInspected: "НІЧОГО не перевірено — це не довідка про добре здоров'я",
    inspected: 'Перевірені',
    notInspected: 'НЕ перевірені',
    localHint: 'Локальні області вузла (юніти systemd, журнал) читаються лише з CLI: tvirt diagnose --area local — шлях, коли API не відповідає.',
    thresholds: 'невдалі завдання за {hours} год, heartbeat запізнюється понад {seconds} с',
    severity: {
      critical: 'Критично',
      warning: 'Попередження',
      unknown: 'Невідомо'
    }
  },
  explorer: {
    title: 'Оглядач ресурсів',
    root: 'Корінь',
    empty: 'У цьому скоупі немає жодного ресурсу',
    previewHint: 'Виберіть об’єкт, щоб побачити його попередній перегляд',
    open: 'Відкрити',

    // Глибоке посилання ?scope= у списках CRUD (раунд #109), з оглядача (#143).
    openScoped: 'Відкрити перелік у цьому скоупі',
    kinds: {
      vm: 'ВМ',
      vmTemplate: 'Шаблон ВМ',
      ct: 'CT',
      ctTemplate: 'Шаблон CT',
      app: 'Застосунок',
      overlayNetwork: 'Оверлейна мережа',
      networkService: 'Мережева служба',
      fabric: 'Фабрика',
      subnet: 'Підмережа',
      storage: 'Пул сховища',
      disk: 'Диск',
      catalogFile: 'Файл каталогу',
      ociRegistry: 'Реєстр OCI',
      ociImage: 'Образ OCI',
      cephCluster: 'Кластер Ceph',
      backupDestination: 'Ціль резервного копіювання',
      user: 'Користувач',
      group: 'Група',
      role: 'Роль',
      credential: 'Облікові дані',
      tag: 'Тег',
      proximityRule: 'Правило Proximity'
    }
  },
  tags: {
    title: 'Теги',
    empty: 'Тегів немає',
    add: 'Додати тег',
    remove: 'Вилучити',
    name: 'Тег',
    value: 'Значення',
    save: 'Зберегти',
    saveError: 'Не вдалося зберегти теги',
    loadError: 'Не вдалося завантажити словник тегів',
    noVocabulary: 'Для цього типу ресурсу немає доступних тегів',

    // Уже заданий одинарний тег відповідає 409: заміна завжди явна — ніколи
    // не неявна підстановка (дизайн, ратифіковано 2026-07-27).
    overwrite: 'Замінити поточне значення',

    // Система > Теги — поверхня словника.
    createTitle: 'Створити тег',
    editTitle: 'Змінити тег',
    nameHint: 'Літери, цифри, крапки, дефіси та підкреслення — без ":" і "/"; префікс tvirt- зарезервовано для платформи',
    cardinality: 'Кардинальність',
    cardinalitySingle: 'Одне значення',
    cardinalityMultiple: 'Кілька значень',
    cardinalityHint: 'З одним значенням повторне призначення тега вимагає замінити його',
    autoCreate: 'Автостворення значень',
    autoCreateOn: 'Під час призначення',
    autoCreateOff: 'Лише оголошені',
    autoCreateHint: 'Увімкнено: призначення нового значення створює його. Вимкнено: призначаються лише оголошені значення',
    values: 'Значення',
    noValues: 'Не оголошено жодного значення',
    addValue: 'Додати значення',
    duplicateValue: 'Дубльоване значення',
    kinds: 'Типи ресурсів',
    kindsAll: 'Усі',
    kindsPlaceholder: 'Усі',
    kindsHint: 'Залиште порожнім, щоб дозволити будь-який тип ресурсу, який можна тегувати',
    systemChip: 'Системний',
    deleteCascade: 'Видалити також призначення',
    deleteCascadeHint: 'Тег, який досі призначено якомусь ресурсу, відхиляється: з цією опцією значення та всі призначення зникають разом із тегом.'
  },
  scopes: {
    title: 'Скоупи',
    createTitle: 'Створити скоуп',
    editTitle: 'Перейменувати скоуп',
    path: 'Шлях',
    segment: 'Сегмент',
    segmentHint: 'Малі літери, цифри та дефіси (DNS-1123)',
    parent: 'Батьківський',
    rootChip: 'Корінь',
    preview: 'Новий скоуп',
    pickLabel: 'Скоуп',
    pickHint: 'Де об’єкт живе в дереві кластера — у корені або в одному з vDC усередині нього.',
    ociCache: 'Кеш OCI (перевизначення)',
    appEphemeral: 'Ефемерні пули застосунків (перевизначення)',
    inherit: 'Успадковувати',
    inheritsFrom: 'Успадковує від',
    inheritsCluster: 'Успадковує типове значення кластера',
    inheritsNone: 'Успадковує — дієвого пулу немає',
    failoverProtection: 'Захист у деградованому кластері',
    networkWeight: 'Мережева вага',
    networkCeil: 'Мережева стеля (Мбіт/с)',
    protectionProtected: 'Захищена',
    protectionExpendable: 'Жертовна при деградації',
    protectionDefault: 'Типове для кластера'
  },

  // Система > Відомості (раунд #124, 2026-07-31): версії платформи у флоті
  // (щонайбільше дві під час оновлення), компоненти кожного вузла, посібник
  // у PDF, що подається локально, і вбудована картка ліцензії.
  sysinfo: {
    summary: 'Версії платформи в кластері, компоненти кожного вузла, посібник адміністратора і ліцензія.',
    platformTitle: 'Платформа TVirt',
    platformSubtitle: 'Версії, спостережені на вузлах кластера',
    versionOnNodes: '{version} на {n} вузлах',
    versionOnOneNode: '{version} на 1 вузлі',
    mixedVersions: 'У кластері більш ніж одна версія платформи — це очікувано лише під час оновлення (щонайбільше дві).',
    tooManyVersions: 'У кластері більш ніж дві версії платформи — такого не очікують ніколи, навіть під час оновлення: перевірте вузли нижче.',
    unreportedNodes: 'Досі немає звіту про версії від: {nodes}',
    noVersionsYet: 'Жоден вузол ще не повідомив своїх версій.',
    nodesUnavailable: 'Перелік вузлів не видно з вашими дозволами — показати версії платформи неможливо.',
    colNode: 'Вузол',
    manualTitle: 'Посібник адміністратора',
    manualSubtitle: 'Локальна копія, яку подає цей кластер',
    manualBody: 'Повний посібник TVirt у PDF, що подається безпосередньо платформою — доступний і в середовищах, ізольованих від зовнішньої мережі.',
    manualLink: 'Посібник адміністратора (PDF)',
    apiExplorerTitle: 'Оглядач API',
    apiExplorerSubtitle: 'Контракт OpenAPI, доступний для перегляду',
    apiExplorerBody: 'Повний контракт OpenAPI платформи — кожен маршрут, схема та код відповіді — доступний для перегляду з браузера, надається через цей вузол.',
    apiExplorerLink: 'Дослідити API',
    kubeTitle: 'Сумісність із Kubernetes',
    kubeSubtitle: 'kubectl та його інструменти перед нативним API',
    kubeBody: 'TVirt KubeCompat проєктує Pod-и, Deployment-и, Service-и, namespace-и, вузли та події в діалект Kubernetes — лише читання, плюс видалення Deployment-ів. Кожен виклик проходить через нативний API з твоїми правами: у kubeconfig використовуй app token як bearer.',
    kubeEndpoint: 'Endpoint для kubectl',
    kubeStatusActive: 'Активний — Kubernetes {version}',
    kubeStatusMissing: 'Не встановлено на цьому вузлі (пакет trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Встановлено, але не відповідає — перевір юніт trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Перевірка…'
  },

  // Ліцензування (раунд 2026-07-29): сторінка ліцензії за підпискою.
  licensing: {
    title: 'Ліцензія кластера',
    subtitle: 'Ліцензія за підпискою — щонайбільше одна на кластер',
    absentTitle: 'Не зареєстровано жодної ліцензії',
    absentBody:
      'Без чинної ліцензії кластер відмовляється запускати нові віртуальні машини (увімкнені ВМ лишаються увімкненими). Зареєструйте ключ продукту, отриманий разом із підпискою.',
    registerButton: 'Зареєструвати ліцензію',
    removeButton: 'Вилучити ліцензію',
    state: {
      ok: 'Чинна',
      limitExceeded: 'Ліміт перевищено',
      expired: 'Термін дії минув'
    },
    productKeyLabel: 'Ключ продукту',
    basisLabel: 'Основа ліміту',
    basis: {
      concurrentVms: 'Одночасно ввімкнені ВМ',
      physicalCores: 'Фізичні ядра (усього в кластері)'
    },
    limitLabel: 'Ліміт',
    usageLabel: 'Поточне використання',
    usageOf: '{used} з {limit}',
    usagePartial: 'часткова сума — {n} вузол(-ів) без спостереженої топології CPU',
    usageUnknown: 'наразі неможливо спостерегти',
    expiresLabel: 'Термін дії',
    neverExpires: 'ніколи',
    registeredLabel: 'Зареєстровано',
    gateNote:
      'Коли ліцензії немає, її термін минув або ліміт перевищено, кластер відмовляється запускати НОВІ віртуальні машини. Увімкнені ВМ лишаються увімкненими, а перезапуски HA від цього не страждають.',
    devStage:
      'Стадія розробки: ключ продукту приймається як є, разом з оголошеними тут лімітами; перевірка підписаним ключем прийде в майбутньому випуску.',
    dialogTitle: 'Зареєструвати ліцензію',
    dialogExpiresHelp: 'Порожньо = ліцензія не має терміну дії',
    dialogSubmit: 'Зареєструвати',
    dialogError: 'Не вдалося зареєструвати ліцензію.',
    removeTitle: 'Вилучити ліцензію',
    removeBody:
      'Кластер залишиться БЕЗ ЛІЦЕНЗІЇ: нові віртуальні машини відмовлятимуться запускатися, доки ви не зареєструєте нову. Увімкнені ВМ лишаються увімкненими.',
    removeConfirm: 'Вилучити',
    removeError: 'Не вдалося вилучити ліцензію.'
  },
  rbac: {
    tabRoles: 'Ролі',
    tabGrants: 'Делегування',
    rolesTitle: 'Ролі',
    createRoleTitle: 'Створити роль',
    editRoleTitle: 'Змінити роль',
    nameHint: 'Малі літери, цифри та дефіси; префікс tvirt- зарезервовано',
    systemChip: 'Системна',
    permissions: 'Дозволи',
    permissionsPlaceholder: 'Додати дозвіл…',
    includedRoles: 'Включені ролі',
    includedRolesPlaceholder: 'Додати роль…',
    grantsTitle: 'Делегування',
    createGrantTitle: 'Створити делегування',
    principal: 'Принципал',
    principalKind: 'Тип принципала',
    principalUser: 'Користувач',
    principalGroup: 'Група',
    role: 'Роль',
    grantRight: 'Делегування',
    grantRightChip: 'Може делегувати',
    grantRightLabel: 'З правом делегування (отримувач може у свою чергу делегувати цю роль)',
    effective: 'Дієве',
    notEffective: 'Недієве',
    createdAt: 'Створено',
    scopeHint: 'точний /path, рекурсивний /path/* — делегування прив’язуються до змонтованого кореня (/* делегувати не можна)'
  },
  groups: {
    title: 'Групи',
    createTitle: 'Створити групу',
    nameHint: 'Малі літери, цифри та дефіси; унікальна в межах скоупу',
    members: 'Учасники',
    membersTitle: 'Учасники',
    membersPlaceholder: 'Додати користувача…',
    noMembers: 'Учасників немає',
    realmMappings: 'Зіставлення з реалмами',
    realmMappingsTitle: 'Зіставлення з реалмами',
    realmMappingsHint:
      'Чому відповідає ця група в кожному зовнішньому реалмі. Належність читається з каталогу в мить входу: групу каталогу, яку тут ніхто не зіставив, буде проігноровано, а вкладеність не розгортається — її треба сплощити на боці каталогу.',
    realm: 'Реалм',
    externalGroup: 'Зовнішня група',
    addRealmMapping: 'Додати зіставлення',
    removeRealmMapping: 'Вилучити зіставлення',
    noRealmMappings: 'Зіставлень з реалмами немає',

    // Діалог створення з секціями (раунд realm-wizard, 2026-08-03): «Загальне»
    // плюс поверхня зіставлення із зовнішніми реалмами та промовистий порожній
    // стан.
    sectionGeneral: 'Загальне',
    mappingsNoRealms: 'Не налаштовано жодного зовнішнього реалму — поверхня зіставлення розблокується, щойно з’явиться реалм.',
    mappingsNoRealmsLink: 'Відкрити вкладку «Реалми та SSO»',

    // Вимога MFA, накладена групою (раунд #178, половина B): чисте OR —
    // група може вимогу лише ДОДАТИ, ніколи її не зняти.
    mfaRequired: 'Вимога MFA',
    mfaRequiredChip: 'Вимагає MFA',
    mfaNotRequiredChip: 'Без вимоги',
    mfaRequiredHint:
      'Чисте OR: група може ДОДАТИ вимогу другого фактора своїм учасникам — зокрема зовнішнім ідентичностям, через зіставлення з реалмами, — але ніколи її не зняти. Діє з наступного входу: відкриті сесії не закриваються.'
  },
  users: {
    title: 'Користувачі',
    createTitle: 'Створити користувача',
    editTitle: 'Змінити користувача',
    username: 'Ім’я користувача',
    usernameHint: 'Малі літери, цифри, крапки та дефіси',
    displayName: 'Показуване ім’я',
    enabled: 'Увімкнений',
    state: 'Стан',
    enabledChip: 'Увімкнений',
    disabledChip: 'Вимкнений',
    lockedChip: 'Заблокований',
    password: 'Пароль',
    passwordSetChip: 'Задано',
    mustChangeChip: 'Треба змінити',
    initialPassword: 'Початковий пароль',
    initialPasswordHint: 'Користувач муситиме змінити його під час першого входу',
    lastLogin: 'Останній вхід',
    neverLoggedIn: 'Ніколи не входив',
    setPasswordTitle: 'Задати пароль',
    setPasswordHint: 'Адміністративна заміна — потребує вашого пароля (режим sudo) і зобов’язує користувача змінити його під час наступного входу.',
    operatorPassword: 'Ваш пароль',
    unlock: 'Розблокувати обліковий запис',
    revokeTitle: 'Відкликати сесії',
    revokeBody: 'Усі активні сесії цього користувача негайно припиняються.',
    revokeIncludeTokens: 'Відкликати також токени застосунків',
    revokeConfirm: 'Відкликати',

    // Стандартний діалог (раунд #156): повні деталі, вкладки облікового запису та безпеки.
    tabAccount: 'Обліковий запис',
    tabSecurity: 'Безпека',
    usernameImmutableHint: 'Ім’я користувача — це ідентичність облікового запису, зафіксована під час створення',
    groups: 'Групи',
    noGroups: 'Груп немає',
    mustChangePassword: 'Обов’язкова зміна пароля',
    failedAttempts: 'Невдалі спроби входу',
    lockedUntil: 'Заблоковано до',

    // Вкладки ідентичностей (2026-08-03): «Система > Користувачі» стала
    // розділом із вкладками за зразком /system/rbac — користувачі, групи,
    // зовнішні реалми.
    tabUsers: 'Користувачі',
    tabGroups: 'Групи',
    tabRealms: 'Реалми та SSO',
    tabMfa: 'MFA',

    // Вкладка MFA (завдання #178, половина A — GUI на наявному контракті):
    // подання другого фактора для кожного користувача. Реєстрації зовнішніх
    // ідентичностей та осиротілий стан — це половина B: раунд контракту,
    // ніколи не форма без бекенда.
    mfa: {
      title: 'Другий фактор (MFA)',
      methodsTitle: 'Доступні методи',
      methodsSubtitle: 'Те, що ця інсталяція вміє перевіряти як другий фактор',
      methodsError: 'Не вдалося завантажити реєстр методів',
      builtinChip: 'Вбудований',
      enrollableChip: 'Реєстрація в TVirt',
      delegatedChip: 'Керується ззовні',
      state: 'Стан',
      stateActive: 'Активний',
      statePending: 'Очікує реєстрації',
      stateNone: 'Не зареєстровано',
      required: 'Вимога MFA',
      requiredChip: 'Обов’язковий',
      notRequiredChip: 'Необов’язковий',
      enrolledAt: 'Зареєстровано',
      enrolledMethods: 'Зареєстровані методи',
      noMethods: 'Реєстрацій немає',
      codesRemaining: 'Залишилося кодів відновлення',
      resetTitle: 'Скинути другий фактор',
      resetHint:
        'Реєстрацію та всі коди відновлення буде обнулено: під час наступного входу користувач пройде реєстрацію заново. Вимога MFA лишається як є — адміністратор ніколи не задає секрет, він лише обнуляє його.',
      resetConfirm: 'Скинути',
      resetError: 'Не вдалося скинути другий фактор',
      empty: 'Керованих користувачів ще немає — облікові записи з’являться тут, щойно виникнуть, кожен зі своїм станом другого фактора.',

      // Половина B (раунд #178): походження чинного вердикту, зовнішні
      // реєстрації зі станом сироти, групи, що накладають вимогу.
      viaSelf: 'Особиста',
      viaSelfHint: 'Особистий внесок облікового запису (його прапорець) — єдина частина, яку редагує олівець.',
      viaGroupHint: 'Вимога, успадкована від цієї групи: зняття особистого прапорця не звільняє користувача — діяти треба на групі, у вкладці «Групи».',
      subject: 'Ідентичність',
      lastSeenAt: 'Останнє підтвердження',
      enrollmentPending: 'Очікує',
      orphanChip: 'Осиротіла',
      orphanDirectoryMiss: 'Ідентичності більше немає в каталозі',
      orphanRealmRemoved: 'Реалм вилучено з TVirt',
      orphanedAt: 'Осиротіла з',
      directoryUuid: 'UUID у каталозі',
      externalTitle: 'Зовнішні реєстрації',
      externalEmpty: 'Зовнішніх реєстрацій ще немає — реєстрація народжується під час першого входу ідентичності каталогу з вимогою MFA.',
      orphanHelp:
        'Осиротіла реєстрація ніколи не видаляється сама: це матеріал безпеки — вона лишається для аудиту, і якщо ідентичність знову з’явиться в каталозі, вона віднайде свій фактор. Єдиний вихід — адміністративне скидання.',
      visibilityHint: 'Зовнішні реєстрації мешкають у корені кластера: їх бачить лише той, хто має user.read на все дерево.',
      orphanResetHint:
        'Осиротілий рядок вилучається остаточно: його вже ніхто не потребує. Якщо ідентичність повернеться до каталогу, вона пройде реєстрацію заново.',
      enforcingTitle: 'Групи, що вимагають MFA',
      enforcingSubtitle:
        'Якорем вимоги для зовнішніх ідентичностей є група: її зіставлення з реалмами кажуть, якої популяції каталогу вона сягає. Зовнішня реєстрація народжується під час першого входу зобов’язаного користувача.',
      enforcingEmpty: 'Жодна група не вимагає MFA — вимога вмикається на групі, у вкладці «Групи».',
      enforcingError: 'Не вдалося завантажити групи, що вимагають MFA'
    }
  },
  realms: {
    title: 'Реалми автентифікації',
    createTitle: 'Створити реалм',
    editTitle: 'Змінити реалм',
    name: 'Реалм',
    nameHint: 'Домен, який користувачі пишуть після @ (example.com) — незмінний після створення',
    nameImmutableHint: 'Назва реалму карбується в кожній сесії та в кожному рядку аудиту, який її колись назвав — перейменування переписало б історію',
    kind: 'Тип',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'OIDC і SAML прийдуть у наступних раундах — сьогодні реалм є каталогом LDAPv3',

    // Напівмайстер створення (раунд realm-wizard, 2026-08-03): картки типів
    // на кроці 1 — ldap живий, картки oidc/saml у дорожній карті (ніколи
    // форма без бекенда за нею).
    kindCategory: 'Тип реалму',
    kindSelectHint: 'Виберіть тип каталогу, на якому цей реалм автентифікуватиме.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Ім’я користувача та пароль перевіряються прив’язкою до каталогу LDAPv3 — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Єдиний вхід із браузера, делегований провайдеру ідентичностей OpenID Connect — прийде в наступних раундах.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Корпоративний єдиний вхід із твердженнями SAML 2.0 — прийде в наступних раундах.'
      }
    },
    tabBind: 'Прив’язка',
    enabled: 'Увімкнений',
    urls: 'Сервери каталогу',
    urlsHint: 'По одному URL ldap:// або ldaps:// на рядок (1–8), пробуються по черзі — відмовостійкість, ніколи не балансування',
    startTls: 'StartTLS',
    verifyCertificate: 'Перевіряти сертифікат',
    cleartextWarning: 'Без ldaps:// чи StartTLS пароль прив’язки мандрує мережею у відкритому вигляді — прийнятно в лабораторії, ніколи у промисловому середовищі.',
    noVerifyWarning: 'Неперевірена сесія TLS не автентифікує нікого: вимикайте перевірку лише щодо каталогу, який ви не можете полагодити.',
    caCertificate: 'Сертифікат CA (PEM)',
    caCertificateHint: 'Необов’язковий набір CA, зафіксований для рукостискання TLS/StartTLS цього реалму; порожнє поле його прибирає',
    caCertificatePinned: 'Зафіксовано',
    connectTimeout: 'Тайм-аут (секунди)',
    connectTimeoutHint: 'Обмеження на з’єднання та запит для кожного URL (1–60); коли воно спливає, пробується наступний URL',
    bindDn: 'Bind DN',
    bindDnHint: 'Службовий обліковий запис, який виконує пошук користувача; порожньо = анонімна прив’язка для пошуку (AD її відхиляє)',
    anonymousBind: 'Анонімна прив’язка для пошуку',
    bindCredential: 'Пароль прив’язки (сховище ключів)',
    bindCredentialHint: 'Запис usernamePassword у сховищі ключів із паролем прив’язки — секрет ніколи не живе на самому реалмі',
    bindCredentialNone: 'Немає (анонімна прив’язка)',
    bindCredentialEmpty: 'У сховищі ключів немає жодного запису usernamePassword — створіть його в розділі «Система > Облікові дані» для пароля прив’язки.',
    baseDn: 'Base DN',
    baseDnHint: 'Піддерево, з якого починається пошук користувача (DC=example,DC=com)',
    userFilter: 'Фільтр користувача',
    userFilterHint: '%u замінюється локальною частиною логіна з екрануванням за RFC 4515; каталоги, відмінні від AD, зазвичай хочуть (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'Атрибут memberOf',
    memberOfAttributeHint: 'Читається лише раз, під час входу — незіставлені групи ігноруються, вкладеність не розгортається',
    uuidAttribute: 'Атрибут UUID',
    uuidAttributeHint: 'Незмінний UUID у межах реалму (objectGUID в AD, entryUUID в OpenLDAP) — карбується в аудиті поруч із користувач@реалм',
    displayNameAttribute: 'Атрибут показуваного імені',
    displayNameAttributeHint: 'Використовується, щоб привітати користувача; за його відсутності береться ім’я входу',
    sudoHint: 'Записи до реалмів захищені sudo: реалм — це вхідні двері до платформи',
    deleteBody: 'Зіставлення груп реалму зникають разом із ним; сесії, які він автентифікував, лишаються живими до закінчення терміну — видалений реалм просто більше нікого не впускає.',
    tabConnection: 'З’єднання',
    tabDirectory: 'Каталог',
    testTitle: 'Перевірити з’єднання',
    testHint: 'Це проба конфігурації, а не автентифікація: з’єднується, робить прив’язку службовим обліковим записом і — якщо задано ім’я користувача — виконує фільтр користувача.',
    testUsername: 'Ім’я користувача (необов’язково)',
    testUsernameHint: 'Локальна частина, на якій виконати фільтр користувача — 1 збіг є здоровою відповіддю',
    testRun: 'Виконати пробу',
    testError: 'Не вдалося виконати пробу',
    testReachable: 'Каталог доступний, службову прив’язку прийнято',
    testUnreachable: 'Каталог НЕдоступний',
    matchedOne: 'Фільтр користувача знайшов рівно 1 запис — здорова відповідь.',
    matchedNone: 'Фільтр користувача не знайшов жодного запису: неправильний фільтр або base DN.',
    matchedMany: 'Фільтр користувача знайшов записів: {count} — він не селективний, і входи були б неоднозначними (відхиленими).',
    mappingsPointer: 'Чому відповідає зовнішня група — це властивість групи TVirt (її зіставлень з реалмами): точка істини живе у вкладці «Групи».',
    mappingsPointerLink: 'Відкрити вкладку «Групи»',
    rootHomeHint: 'Ідентичності зовнішнього реалму живуть у корені кластера, ніколи у vDC: дозволи призначаються там, де потрібні, через делегування — на групу або прямо на користувача, точно як для рідних.'
  },
  credentials: {
    title: 'Облікові дані',
    createTitle: 'Створити облікові дані',
    editTitle: 'Змінити облікові дані',
    kind: 'Тип',
    kindUsernamePassword: 'Ім’я користувача та пароль',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (ідентичність Ceph)',
    kindHintUsernamePassword: 'Незмінний. Для сховищ CIFS/SMB — обліковий запис монтування, секрет якого воркер використовує в мить монтування.',
    kindHintIscsiChap: 'Незмінний. Для автентифікації CHAP в iSCSI — ім’я користувача = ім’я CHAP, секрет = секрет CHAP.',
    kindHintNvmeDhchap: 'Незмінний. Для DH-HMAC-CHAP у NVMe over Fabrics — секрет = блоб DHHC-1:xx:…; ім’я користувача тут лише мітка.',
    kindHintCephx: 'Незмінний. Для клієнтів Ceph — ім’я користувача = ім’я клієнта (client.…), секрет = ключ у base64.',
    kindImmutableHint: 'Тип незмінний після створення — змінити його означає завести нові облікові дані.',
    username: 'Ім’я користувача',
    usernameChap: 'Ім’я CHAP',
    usernameNvme: 'Мітка',
    usernameCephx: 'Ім’я клієнта',
    usernameHint: 'Необов’язковий обліковий запис, якому належить секрет',
    usernameHintChap: 'Ім’я CHAP, яким автентифікується ініціатор',
    usernameHintNvme: 'Транспорт її не використовує — вільна мітка для ваших нотаток',
    usernameHintCephx: 'Ім’я клієнта cephx — префікс client. допускається',
    secret: 'Секрет',
    secretHint: 'Лише для запису: використовується споживачами, більше ніколи не показується.',
    secretHintNvmeDhchap: 'Лише для запису: секрет хоста DH-HMAC-CHAP у канонічній формі DHHC-1:xx:… — використовується споживачами, більше ніколи не показується.',
    secretHintCephx: 'Лише для запису: ключ cephx у base64 — використовується споживачами, більше ніколи не показується.',
    secretEditHint: 'Залиште порожнім, щоб не змінювати секрет — заповнення його ротує.',
    createdAt: 'Створено',
    inUseError: 'На «{name}» посилається конфігурація одного зі сховищ — спершу від’єднайте їх там.',
    nameHint: 'Малі літери, цифри та дефіси (DNS-1123); унікальна в межах скоупу',

    // Діалог самої лише ротації (раунд #156): секрет ніколи не має вбудованого олівця.
    rotateTitle: 'Ротувати секрет',
    rotateHint: 'Лише для запису: новий секрет замінює збережений — споживачі скористаються ним під час наступного монтування.',

    // Раунд #159 (PKI): вкладки «Сертифікати» та «Центри сертифікації».
    tabSecrets: 'Секрети',
    tabCertificates: 'Сертифікати',
    tabAuthorities: 'Центри сертифікації',
    certificatesTitle: 'Сертифікати',
    authoritiesTitle: 'Центри сертифікації',
    caCreateTitle: 'Новий CA',
    certCreateTitle: 'Новий сертифікат',
    caMode: 'Походження',
    caModeGenerate: 'Згенерувати в TVirt',
    caModeImport: 'Імпортувати (ключ + сертифікат)',
    certMode: 'Походження',
    certModeIssue: 'Видати від CA зі сховища ключів',
    certModeImport: 'Імпортувати (ключ + сертифікат)',
    issuingCa: 'CA-емітент',
    issuingCaHint: 'Сертифікат народжується у скоупі CA, із зареєстрованим батьком',
    noCasHint: 'У сховищі ключів немає жодного CA — спершу згенеруйте або імпортуйте його у вкладці CA',
    commonName: 'Загальне ім’я (CN)',
    commonNameCaHint: 'Суб’єкт CA: літери, цифри, пробіл, крапка, підкреслення, дефіс',
    commonNameCertHint: 'OpenVPN розпізнає клієнтів за CN — тримайте його унікальним у межах CA',
    days: 'Термін дії (дні)',
    daysCaHint: '1–7300 днів; типово 3650 (10 років)',
    daysCertHint: '1–3650 днів; типово 365',
    keyType: 'Тип ключа',
    keyTypeHint: 'EC P-256 — типовий; RSA для застарілих споживачів',
    usage: 'Призначення',
    usageClient: 'Клієнт (clientAuth)',
    usageServer: 'Сервер (serverAuth)',
    usageHint: 'Розширене призначення ключа, для якого видається сертифікат',
    san: 'Альтернативні імена (SAN)',
    sanHint: 'Через кому; літеральні IP стають записами IP:, решта — DNS:',
    keyPem: 'Приватний ключ (PEM)',
    keyPemHint: 'Лише для запису: зберігається у сховищі ключів, більше ніколи не показується',
    certPem: 'Сертифікат (PEM)',
    certPemHint: 'Публічний сертифікат, що складається в пару з ключем',
    certPemCaHint: 'Сертифікат CA, що складається в пару з ключем (basicConstraints CA)',
    subject: 'Суб’єкт',
    issuer: 'Емітент',
    parentCa: 'CA-емітент',
    parentCaImported: 'Імпортований — виданий поза TVirt',
    serial: 'Серійний номер',
    fingerprint: 'Відбиток (SHA-256)',
    validFrom: 'Дійсний з',
    validUntil: 'Дійсний до',
    expiry: 'Термін дії',
    expired: 'Термін минув',
    expiresInDays: 'Спливає через {days} дн.',
    revoked: 'Відкликаний',
    revokedAtLabel: 'Відкликано',
    revokeTitle: 'Відкликати сертифікат',
    revokeAction: 'Відкликати',
    revokeWarning: 'Відкликання остаточне: серійний номер потрапляє до CRL емітента, і кожен споживач, який відхиляє відкликані сертифікати (насамперед OpenVPN), відкине цей. Скасувати відкликання неможливо.',
    exportPem: 'Експортувати PEM',
    exportChain: 'Експортувати набір ланцюжка',
    exportCrl: 'Експортувати CRL',
    materialImmutableHint: 'Матеріал X.509 незмінний — перевидайте або переімпортуйте',
    caInUseError: '«{name}» ще має живі видані сертифікати (або на нього посилається сховище) — спершу відкличте чи видаліть їх.'
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Розміщення, доступність і спорідненість — де працюють ВМ кластера і чи мають вони бути ввімкненими',
    loadError: 'Панель Proximity потребує сховища конфігурації кластера — стан флоту зараз недосяжний',
    config: {
      title: 'Конфігурація',
      subtitle: 'Політика розміщення на рівні кластера',
      save: 'Зберегти',
      saveError: 'Конфігурацію відхилено',
      strategy: 'Стратегія вибору',
      strategy_leastUsedResources: 'Найменше використаних ресурсів',
      strategy_leastVms: 'Найменше ВМ',
      strategy_random: 'Випадково',
      strategyLeastUsedResourcesHint: 'Серед придатних кандидатів — вузол із найбільшим залишком доступної RAM (спостережений загальний обсяг − резерв хоста − увімкнені ВМ), зобов’язання vCPU як розв’язання нічиєї. Детермінована за однакових даних.',
      strategyLeastVmsHint: 'Серед придатних кандидатів — вузол із найменшою кількістю увімкнених ВМ; нічия розв’язується за назвою. Детермінована за однакових даних.',
      strategyRandomHint: 'Рівномірно випадково серед придатних кандидатів.',
      liveness: 'Поріг життєздатності вузлів (секунди)',
      livenessHint: 'Учасник, що мовчить понад поріг, вважається недоступним: його виключають з розміщення і — якщо він не на обслуговуванні — вирішувач HA вважає його мертвим, ізолює його та перезапускає його ВМ з HA деінде.',
      decider: 'Вирішувач HA',
      deciderNone: 'ще не обраний'
    },
    nodesTitle: 'Вузли',
    nodesSubtitle: 'Життєздатність та емпірична ємність — доступна RAM = загалом − база − зайнято',
    nodeCol: 'Вузол',
    stateCol: 'Стан',
    ramCol: 'RAM (загалом − база − зайнято)',
    usableCol: 'Доступно',
    vmsCol: 'Навантаження',
    neverSeen: 'ніколи не бачено',
    freshChip: 'доступний',
    staleChip: 'недоступний',
    attestedChip: 'засвідчено вимкненим',
    ramFormula: 'загалом − база − зайнято',
    haTitle: 'Висока доступність',
    haSubtitle: 'ВМ із прапорцем HA «завжди ввімкнені»: TVirt перезапускає їх після кожної незапитаної зупинки — на тому самому вузлі з відкладанням, на іншому вузлі, коли їхній помирає (лише спільне сховище).',
    haNone: 'Жодна ВМ ще не має прапорця HA — увімкніть його тут або в деталях ВМ.',
    haVmCol: 'Віртуальна машина',
    haStateCol: 'Стан',
    haRestartsCol: 'Перезапуски HA',
    haLastEventCol: 'Остання подія',
    haToggleCol: 'HA',
    haCrashLoop: 'цикл збоїв',
    haToggleError: 'Зміну HA відхилено',
    rules: {
      title: 'Правила спорідненості',
      createTitle: 'Нове правило Proximity',
      editTitle: 'Змінити правило',
      nameHint: 'Малі літери, цифри та дефіси (мітка DNS)',
      vms: 'Віртуальні машини',
      vmsHint: 'Щонайменше дві ВМ — правило обмежує, де вони працюють одна щодо одної',
      type: 'Тип',
      affinity: 'Спорідненість (разом)',
      antiAffinity: 'Антиспорідненість (окремо)',
      typeAffinityHint: 'ВМ мають працювати на ОДНОМУ вузлі.',
      typeAntiAffinityHint: 'ВМ мають працювати на РІЗНИХ вузлах — класична пара HA.',
      mode: 'Режим',
      hard: 'жорсткий',
      soft: 'м’який',
      modeHardHint: 'Порушення відхиляють операцію (запуск, міграцію, аварійне перемикання) зі змістовною помилкою.',
      modeSoftHint: 'Уподобання, ніколи не блокує: розміщення з порушенням відбувається з видимим попередженням.',
      satisfied: 'Розміщення',
      satisfiedYes: 'дотримано',
      satisfiedNo: 'порушено',

      // Стандартний діалог (раунд #156): порушення мають власний рядок, а не підказку.
      violations: 'Порушення',
      noViolations: 'Немає'
    },
    events: {
      title: 'Події HA',
      subtitle: 'Журнал доступності — перезапуски, ізоляція, аварійні перемикання та чесні пропуски',
      none: 'Поки що нічого.',
      when: 'Коли',
      kind: 'Подія',
      target: 'Об’єкт',
      detail: 'Деталі',
      kindRestarted: 'перезапуск HA',
      kindGaveUp: 'відмова (цикл збоїв)',
      kindNodeAttested: 'вузол ізольовано',
      kindFailedOver: 'аварійне перемикання',
      kindNoCandidate: 'немає кандидата',
      kindStorageLocalSkip: 'пропущено (локальне сховище)',
      kindZombieFenced: 'зомбі знищено'
    }
  }
}
